export default {
    init() {
      // JavaScript to be fired on form faq template

      // if ($('.wpcf7-acceptance').length > 0) {
      //   $('.wpcf7-acceptance input[type="checkbox"]').after('<span></span>');
      // }

      // Disabilita input hidden form
      $('form').on('wpcf7cf_hide_group', function(e) {
        $(e.target).find('input').attr('disabled', true);
      });
      $('form').on('wpcf7cf_show_group', function(e) {
        $(e.target).find('input').removeAttr('disabled');
      });

      // Solo numeri campo tel
      $('input[type="tel"]').on('input', function() {
        $(this).val($(this).val().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'));
      });

    },
    finalize() {
      // JavaScript to be fired on form faq template, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/form.js